import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup, { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { SxProps, Theme } from '@mui/material';

interface SegmentedOption {
  label: string;
  value: string;
}

interface SegmentedControlProps {
  options?: SegmentedOption[];
  value?: string;
  onChange?: ((value: string) => void) | ((value: any) => void);
  ariaLabel?: string;
  sx?: SxProps<Theme>;
}

export default function SegmentedControl({
  options = [],
  value,
  onChange = () => {},
  ariaLabel = 'Toggle options',
  sx = {},
}: SegmentedControlProps) {
  const handleOnChange = (_: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleOnChange}
      aria-label={ariaLabel}
      size='small'
      sx={{
        border: 'none',
        alignSelf: 'center',
        background: 'transparent',
        [`& .${toggleButtonGroupClasses.firstButton}`]: {
          borderTopLeftRadius: 6,
          borderBottomLeftRadius: 6,
        },
        [`& .${toggleButtonGroupClasses.lastButton}`]: {
          borderTopRightRadius: 6,
          borderBottomRightRadius: 6,
        },
        ...sx,
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          sx={{
            border: 'none',
            px: 2,
            py: 0.5,
            fontSize: '0.875rem',
            textTransform: 'none',
            color: 'text.primary',
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': { backgroundColor: 'primary.main' },
            },
          }}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
